// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InteractivityDetails {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: auto;
}
.InteractivityDetails .Back {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
}
.InteractivityDetails .Back svg {
  cursor: pointer;
}
.InteractivityDetails .Back svg path {
  color: var(--AccentColor);
}
.InteractivityDetails .Back span {
  font-size: 1rem;
  font-weight: 700;
  color: var(--AccentColor);
  cursor: pointer;
}
.InteractivityDetails .DetailsCont {
  flex: 1 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow: auto;
}
.InteractivityDetails .DetailsCont .CandidateDetails {
  width: 100%;
  padding: 0.75rem;
  background: var(--Foreground);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  position: relative;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.25rem;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .Name {
  font-size: 1rem;
  font-weight: 700;
  color: var(--TextColor);
  max-width: 12.5rem;
  min-width: 12.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  font-size: 0.75rem;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow .Status {
  min-width: 5rem;
  padding: 0 0.25rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--TextColor);
  cursor: pointer;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow .Follow {
  min-width: 1.875rem;
  padding: 0 0.25rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  background: var(--Invitation);
  color: var(--TextColor);
  cursor: pointer;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow .invitation {
  background: var(--Invitation);
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow .re-initiated {
  background: var(--Reinitiated);
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow .accepted {
  background: var(--Accepted);
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow .inprogress {
  background: var(--Inprogress);
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow .pending {
  background: var(--Pending);
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow .completed {
  background: var(--Completed);
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .NameStatusFollow .StatusFollow .cancelled {
  background: var(--Cancelled);
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .DetailSection {
  flex: 1 1 12.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.375rem, 1fr));
  gap: 0.625rem 1.25rem;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .DetailSection .LabelValue {
  display: flex;
  flex-direction: column;
  font-size: 0.625rem;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .DetailSection .LabelValue .Label {
  font-weight: 600;
  color: var(--AccentColor);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .DetailSection .LabelValue .Value {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--TextColor);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .Checks {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.75rem 0.5rem;
  height: 3.5rem;
  border-radius: 0.75rem;
  border: 0.0625rem solid var(--Invitation);
  font-size: 0.75rem;
  cursor: pointer;
}
.InteractivityDetails .DetailsCont .CandidateDetails .NameDetailDateChecks .Checks .Che {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  color: var(--TextColor);
  width: 3.125rem;
}
.InteractivityDetails .DetailsCont .CandidateDetails .ChecksContainerWrapper {
  display: grid;
  grid-template-rows: 0fr;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}
.InteractivityDetails .DetailsCont .CandidateDetails .ChecksContainerWrapper .ChecksContainer {
  width: 100%;
  overflow: hidden;
}
.InteractivityDetails .DetailsCont .CandidateDetails .ChecksContainerWrapper .ChecksContainer .ChecksList {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding-top: 0.75rem;
  margin-top: 0.75rem;
  border-top: 0.0625rem solid var(--Stroke);
}
.InteractivityDetails .DetailsCont .CandidateDetails .ChecksContainerWrapper .ChecksContainer .ChecksList .Check {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  border: 0.0625rem solid var(--Stroke);
}
.InteractivityDetails .DetailsCont .CandidateDetails .ChecksContainerWrapper .ChecksContainer .ChecksList .Check span {
  font-size: 0.75rem;
  color: var(--TextColor);
}
.InteractivityDetails .DetailsCont .CandidateDetails .ChecksContainerWrapper .ChecksContainer .ChecksList .Check .TAT {
  font-size: 0.625rem;
  font-weight: 500;
  color: var(--TextColor);
  padding: 0.25rem 0.5rem 0.125rem 0.5rem;
  border-radius: 0.75rem;
  background: var(--Background);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.InteractivityDetails .DetailsCont .CandidateDetails .ChecksContainerWrapper .ChecksContainer .ChecksList .Check .TAT span {
  font-size: 0.625rem;
  color: var(--TextColor);
}
.InteractivityDetails .DetailsCont .CandidateDetails .Show {
  grid-template-rows: 1fr;
  transition: all 0.3s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/Components/DashBoard/InteractivityDetails.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AACJ;AAAI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAEN;AADM;EACE,eAAA;AAGR;AAFQ;EACE,yBAAA;AAIV;AADM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AAGR;AAAI;EACE,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AAEN;AADM;EACE,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAGR;AAFQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAIV;AAHU;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAKZ;AAJY;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAMd;AAJY;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAMd;AALc;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;AAOhB;AALc;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;AAOhB;AALc;EACE,6BAAA;AAOhB;AALc;EACE,8BAAA;AAOhB;AALc;EACE,2BAAA;AAOhB;AALc;EACE,6BAAA;AAOhB;AALc;EACE,0BAAA;AAOhB;AALc;EACE,4BAAA;AAOhB;AALc;EACE,4BAAA;AAOhB;AAHU;EACE,iBAAA;EACA,aAAA;EACA,8DAAA;EACA,qBAAA;AAKZ;AAJY;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAMd;AALc;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAOhB;AALc;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAMhB;AAFU;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;AAIZ;AAHY;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;AAKd;AADQ;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,gCAAA;AAGV;AAFU;EACE,WAAA;EACA,gBAAA;AAIZ;AAHY;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,yCAAA;AAKd;AAJc;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;EACA,qCAAA;AAMhB;AALgB;EACE,kBAAA;EACA,uBAAA;AAOlB;AALgB;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uCAAA;EACA,sBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAOlB;AANkB;EACE,mBAAA;EACA,uBAAA;AAQpB;AADQ;EACE,uBAAA;EACA,gCAAA;AAGV","sourcesContent":[".InteractivityDetails{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    overflow: auto;\n    .Back{\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 0.25rem;\n      svg{\n        cursor: pointer;\n        path{\n          color: var(--AccentColor);\n        }\n      }\n      span{\n        font-size: 1rem;\n        font-weight: 700;\n        color: var(--AccentColor);\n        cursor: pointer;\n      }\n    }\n    .DetailsCont{\n      flex: 1;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n      overflow: auto;\n      .CandidateDetails{\n        width: 100%;\n        padding: 0.75rem;\n        background: var(--Foreground);\n        border-radius: 1rem;\n        display: flex;\n        flex-direction: column;\n        position: relative;\n        .NameDetailDateChecks{\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: 1.25rem;\n          .NameStatusFollow{\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            .Name{\n              font-size: 1rem;\n              font-weight: 700;\n              color: var(--TextColor);\n              max-width: 12.5rem;\n              min-width: 12.5rem;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              cursor: pointer;\n            }\n            .StatusFollow{\n              display: flex;\n              flex-direction: row;\n              gap: 0.75rem;\n              font-size: 0.75rem;\n              .Status{\n                min-width: 5rem;\n                padding: 0 0.25rem;\n                height: 1.5rem;\n                border-radius: 0.25rem;\n                text-transform: capitalize;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: var(--TextColor);\n                cursor: pointer;\n              }\n              .Follow{\n                min-width: 1.875rem;\n                padding: 0 0.25rem;\n                height: 1.5rem;\n                border-radius: 0.25rem;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                gap: 0.25rem;\n                background: var(--Invitation);\n                color: var(--TextColor);\n                cursor: pointer;\n              }\n              .invitation{\n                background: var(--Invitation);\n              }\n              .re-initiated{\n                background: var(--Reinitiated);\n              }\n              .accepted{\n                background: var(--Accepted);\n              }\n              .inprogress{\n                background: var(--Inprogress);\n              }\n              .pending{\n                background: var(--Pending);\n              }\n              .completed{\n                background: var(--Completed);\n              }\n              .cancelled{\n                background: var(--Cancelled);\n              }\n            }\n          }\n          .DetailSection{\n            flex: 1 18.75rem 12.5rem;\n            display: grid;\n            grid-template-columns: repeat(auto-fit, minmax(9.375rem, 1fr));\n            gap: 0.625rem 1.25rem;\n            .LabelValue{\n              display: flex;\n              flex-direction: column;\n              font-size: 0.625rem;\n              .Label{\n                font-weight: 600;\n                color: var(--AccentColor);\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              }\n              .Value{\n                font-size: 0.75rem;\n                font-weight: 400;\n                color: var(--TextColor);\n                // max-width: 12.5rem;\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n              }\n            }\n          }\n          .Checks{\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            gap: 0.25rem;\n            padding: 0.75rem 0.5rem;\n            height: 3.5rem;\n            border-radius: 0.75rem;\n            border: 0.0625rem solid var(--Invitation);\n            font-size: 0.75rem;\n            cursor: pointer;\n            .Che{\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              gap: 0.5rem;\n              color: var(--TextColor);\n              width: 3.125rem;\n            }\n          }\n        }\n        .ChecksContainerWrapper{\n          display: grid;\n          grid-template-rows: 0fr;\n          overflow: hidden;\n          transition: all 0.3s ease-in-out;\n          .ChecksContainer{\n            width: 100%;\n            overflow: hidden;\n            .ChecksList{\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              flex-wrap: wrap;\n              gap: 0.5rem;\n              padding-top: 0.75rem;\n              margin-top: 0.75rem;\n              border-top: 0.0625rem solid var(--Stroke);\n              .Check{\n                display: flex;\n                flex-direction: row;\n                align-items: center;\n                gap: 0.5rem;\n                padding: 0.25rem 0.5rem;\n                border-radius: 0.5rem;\n                border: 0.0625rem solid var(--Stroke);\n                span{\n                  font-size: 0.75rem;\n                  color: var(--TextColor);\n                }\n                .TAT{\n                  font-size: 0.625rem;\n                  font-weight: 500;\n                  color: var(--TextColor);\n                  padding: 0.25rem 0.5rem 0.125rem 0.5rem;\n                  border-radius: 0.75rem;\n                  background: var(--Background);\n                  display: flex;\n                  flex-direction: row;\n                  align-items: center;\n                  gap: 0.5rem;\n                  span{\n                    font-size: 0.625rem;\n                    color: var(--TextColor);\n                  }\n                }\n              }\n            }\n          }\n        }\n        .Show{\n          grid-template-rows: 1fr;\n          transition: all 0.3s ease-in-out;\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
